import './index.css';

import React from 'react';

import ToggleButton from './components/ToggleButton';
import { SideMenuContainer, SideMenuContent, SideMenuSpaceHolder } from './sx';
import { Box } from '@mui/material';
import { useAppSelector } from '../../../reducer/hooks';
import { selectIsMobileView } from '../../../reducer/mediaSlice';

interface IProps {
  children: React.ReactNode;
  isDeskTopMenuCollapse: boolean;
  isShowSideMenuInMobileView: boolean;
  onCollapseClick?: () => void;
}

const SideMenu = ({
  children,
  isDeskTopMenuCollapse,
  isShowSideMenuInMobileView,
  onCollapseClick,
}: IProps) => {
  const isMobileView = useAppSelector(selectIsMobileView);
  const isMobileMenuCollapse = isMobileView && !isShowSideMenuInMobileView;

  return (
    <Box>
      {!isMobileView && <SideMenuSpaceHolder isCollapse={isDeskTopMenuCollapse} />}
      <SideMenuContainer
        isDeskTopMenuCollapse={!isMobileView && isDeskTopMenuCollapse}
        isMobileMenuCollapse={isMobileMenuCollapse}
      >
        {!isMobileView && (
          <ToggleButton onCollapseClick={onCollapseClick} isCollapse={isDeskTopMenuCollapse} />
        )}

        <SideMenuContent isCollapse={isDeskTopMenuCollapse || isMobileMenuCollapse}>
          {children}
        </SideMenuContent>
      </SideMenuContainer>
    </Box>
  );
};

export default SideMenu;
